import { render, staticRenderFns } from "./confirm-phone-form.vue?vue&type=template&id=55332fad&"
import script from "./confirm-phone-form.vue?vue&type=script&lang=js&"
export * from "./confirm-phone-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports